export default "__VITE_ASSET__BuLz7wqG__"